<div class="container-fluid page-header bg-1 bg-image">
  <div class="bg-image-overlay"></div>
  <div class="page-header-inner">
    <h1>{{'ui.applications.title' | translate}}</h1>
    <h2 class="subtitle">{{ 'ui.applications.description' | translate }}</h2>
  </div>
</div>

<div class="container-fluid data-sources">
  <div class="container breathe">
    <div class="row no-gutters">

      @for (app of applications; track app) {
<div class="app-card-wrapper col-xl-4 col-lg-6 col-md-12 col-sm-12 p-3">
        <a class="app-card" [attr.href]="app.link || (app.links && app.links[language]) || null" target="_blank" [class.disabled]="!app.link">
          <div class="app-icon">
            @if (app.image) {
<div class="image" [style.background-image]="'url('+app.image+')'"></div>
}
            @if (app.icon && !app.image) {
<div class="icon">
              <fa-icon [icon]="app.icon"></fa-icon>
            </div>
}
          </div>
          <div class="app-data pl-3">
            <div class="name">{{app.name | translate}}</div>
            <div class="description">{{app.description | translate}}</div>
            @if (!app.comingSoon) {
<div class="platforms">
              @for (platform of app.platforms; track platform) {
<fa-icon [icon]="platform"></fa-icon>
}
            </div>
}
            @if (app.comingSoon) {
<div class="coming-soon">
              <span class="badge badge-primary">{{ 'ui.applications.soon' | translate }}</span>
            </div>
}
          </div>
        </a>
      </div>
}

    </div>
  </div>
</div>
